/**
 * Shopify admin–style country & language lists (parity with your reference selects).
 * Optional regen: `node scripts/gen-country-language.mjs`
 */

const COUNTRY_LINES = `
- AC Ascension Island.
- AD Andorra.
- AE United Arab Emirates.
- AF Afghanistan.
- AG Antigua & Barbuda.
- AI Anguilla.
- AL Albania.
- AM Armenia.
- AN Netherlands Antilles.
- AO Angola.
- AR Argentina.
- AT Austria.
- AU Australia.
- AW Aruba.
- AX Åland Islands.
- AZ Azerbaijan.
- BA Bosnia & Herzegovina.
- BB Barbados.
- BD Bangladesh.
- BE Belgium.
- BF Burkina Faso.
- BG Bulgaria.
- BH Bahrain.
- BI Burundi.
- BJ Benin.
- BL St. Barthélemy.
- BM Bermuda.
- BN Brunei.
- BO Bolivia.
- BQ Caribbean Netherlands.
- BR Brazil.
- BS Bahamas.
- BT Bhutan.
- BV Bouvet Island.
- BW Botswana.
- BY Belarus.
- BZ Belize.
- CA Canada.
- CC Cocos (Keeling) Islands.
- CD Congo - Kinshasa.
- CF Central African Republic.
- CG Congo - Brazzaville.
- CH Switzerland.
- CI Côte d’Ivoire.
- CK Cook Islands.
- CL Chile.
- CM Cameroon.
- CN China.
- CO Colombia.
- CR Costa Rica.
- CU Cuba.
- CV Cape Verde.
- CW Curaçao.
- CX Christmas Island.
- CY Cyprus.
- CZ Czechia.
- DE Germany.
- DJ Djibouti.
- DK Denmark.
- DM Dominica.
- DO Dominican Republic.
- DZ Algeria.
- EC Ecuador.
- EE Estonia.
- EG Egypt.
- EH Western Sahara.
- ER Eritrea.
- ES Spain.
- ET Ethiopia.
- FI Finland.
- FJ Fiji.
- FK Falkland Islands.
- FO Faroe Islands.
- FR France.
- GA Gabon.
- GB United Kingdom.
- GD Grenada.
- GE Georgia.
- GF French Guiana.
- GG Guernsey.
- GH Ghana.
- GI Gibraltar.
- GL Greenland.
- GM Gambia.
- GN Guinea.
- GP Guadeloupe.
- GQ Equatorial Guinea.
- GR Greece.
- GS South Georgia & South Sandwich Islands.
- GT Guatemala.
- GW Guinea-Bissau.
- GY Guyana.
- HK Hong Kong SAR.
- HM Heard & McDonald Islands.
- HN Honduras.
- HR Croatia.
- HT Haiti.
- HU Hungary.
- ID Indonesia.
- IE Ireland.
- IL Israel.
- IM Isle of Man.
- IN India.
- IO British Indian Ocean Territory.
- IQ Iraq.
- IR Iran.
- IS Iceland.
- IT Italy.
- JE Jersey.
- JM Jamaica.
- JO Jordan.
- JP Japan.
- KE Kenya.
- KG Kyrgyzstan.
- KH Cambodia.
- KI Kiribati.
- KM Comoros.
- KN St. Kitts & Nevis.
- KP North Korea.
- KR South Korea.
- KW Kuwait.
- KY Cayman Islands.
- KZ Kazakhstan.
- LA Laos.
- LB Lebanon.
- LC St. Lucia.
- LI Liechtenstein.
- LK Sri Lanka.
- LR Liberia.
- LS Lesotho.
- LT Lithuania.
- LU Luxembourg.
- LV Latvia.
- LY Libya.
- MA Morocco.
- MC Monaco.
- MD Moldova.
- ME Montenegro.
- MF St. Martin.
- MG Madagascar.
- MK North Macedonia.
- ML Mali.
- MM Myanmar (Burma).
- MN Mongolia.
- MO Macao SAR.
- MQ Martinique.
- MR Mauritania.
- MS Montserrat.
- MT Malta.
- MU Mauritius.
- MV Maldives.
- MW Malawi.
- MX Mexico.
- MY Malaysia.
- MZ Mozambique.
- NA Namibia.
- NC New Caledonia.
- NE Niger.
- NF Norfolk Island.
- NG Nigeria.
- NI Nicaragua.
- NL Netherlands.
- NO Norway.
- NP Nepal.
- NR Nauru.
- NU Niue.
- NZ New Zealand.
- OM Oman.
- PA Panama.
- PE Peru.
- PF French Polynesia.
- PG Papua New Guinea.
- PH Philippines.
- PK Pakistan.
- PL Poland.
- PM St. Pierre & Miquelon.
- PN Pitcairn Islands.
- PS Palestinian Territories.
- PT Portugal.
- PY Paraguay.
- QA Qatar.
- RE Réunion.
- RO Romania.
- RS Serbia.
- RU Russia.
- RW Rwanda.
- SA Saudi Arabia.
- SB Solomon Islands.
- SC Seychelles.
- SD Sudan.
- SE Sweden.
- SG Singapore.
- SH St. Helena.
- SI Slovenia.
- SJ Svalbard & Jan Mayen.
- SK Slovakia.
- SL Sierra Leone.
- SM San Marino.
- SN Senegal.
- SO Somalia.
- SR Suriname.
- SS South Sudan.
- ST São Tomé & Príncipe.
- SV El Salvador.
- SX Sint Maarten.
- SY Syria.
- SZ Eswatini.
- TA Tristan da Cunha.
- TC Turks & Caicos Islands.
- TD Chad.
- TF French Southern Territories.
- TG Togo.
- TH Thailand.
- TJ Tajikistan.
- TK Tokelau.
- TL Timor-Leste.
- TM Turkmenistan.
- TN Tunisia.
- TO Tonga.
- TR Türkiye.
- TT Trinidad & Tobago.
- TV Tuvalu.
- TW Taiwan.
- TZ Tanzania.
- UA Ukraine.
- UG Uganda.
- UM U.S. Outlying Islands.
- US United States.
- UY Uruguay.
- UZ Uzbekistan.
- VA Vatican City.
- VC St. Vincent & Grenadines.
- VE Venezuela.
- VG British Virgin Islands.
- VN Vietnam.
- VU Vanuatu.
- WF Wallis & Futuna.
- WS Samoa.
- XK Kosovo.
- YE Yemen.
- YT Mayotte.
- ZA South Africa.
- ZM Zambia.
- ZW Zimbabwe.
- ZZ Unknown Region.
`.trim();

const LANGUAGE_ROWS = [
  ["AF", "Afrikaans"],
  ["AK", "Akan"],
  ["AM", "Amharic"],
  ["AR", "Arabic"],
  ["AS", "Assamese"],
  ["AZ", "Azerbaijani"],
  ["BE", "Belarusian"],
  ["BG", "Bulgarian"],
  ["BM", "Bambara"],
  ["BN", "Bangla"],
  ["BO", "Tibetan"],
  ["BR", "Breton"],
  ["BS", "Bosnian"],
  ["CA", "Catalan"],
  ["CE", "Chechen"],
  ["CKB", "Central Kurdish"],
  ["CS", "Czech"],
  ["CU", "Church Slavic"],
  ["CY", "Welsh"],
  ["DA", "Danish"],
  ["DE", "German"],
  ["DZ", "Dzongkha"],
  ["EE", "Ewe"],
  ["EL", "Greek"],
  ["EN", "English"],
  ["EO", "Esperanto"],
  ["ES", "Spanish"],
  ["ET", "Estonian"],
  ["EU", "Basque"],
  ["FA", "Persian"],
  ["FF", "Fulah"],
  ["FI", "Finnish"],
  ["FIL", "Filipino"],
  ["FO", "Faroese"],
  ["FR", "French"],
  ["FY", "Western Frisian"],
  ["GA", "Irish"],
  ["GD", "Scottish Gaelic"],
  ["GL", "Galician"],
  ["GU", "Gujarati"],
  ["GV", "Manx"],
  ["HA", "Hausa"],
  ["HE", "Hebrew"],
  ["HI", "Hindi"],
  ["HR", "Croatian"],
  ["HU", "Hungarian"],
  ["HY", "Armenian"],
  ["IA", "Interlingua"],
  ["ID", "Indonesian"],
  ["IG", "Igbo"],
  ["II", "Sichuan Yi"],
  ["IS", "Icelandic"],
  ["IT", "Italian"],
  ["JA", "Japanese"],
  ["JV", "Javanese"],
  ["KA", "Georgian"],
  ["KI", "Kikuyu"],
  ["KK", "Kazakh"],
  ["KL", "Kalaallisut"],
  ["KM", "Khmer"],
  ["KN", "Kannada"],
  ["KO", "Korean"],
  ["KS", "Kashmiri"],
  ["KU", "Kurdish"],
  ["KW", "Cornish"],
  ["KY", "Kyrgyz"],
  ["LA", "Latin"],
  ["LB", "Luxembourgish"],
  ["LG", "Ganda"],
  ["LN", "Lingala"],
  ["LO", "Lao"],
  ["LT", "Lithuanian"],
  ["LU", "Luba-Katanga"],
  ["LV", "Latvian"],
  ["MG", "Malagasy"],
  ["MI", "Māori"],
  ["MK", "Macedonian"],
  ["ML", "Malayalam"],
  ["MN", "Mongolian"],
  ["MO", "Moldavian"],
  ["MR", "Marathi"],
  ["MS", "Malay"],
  ["MT", "Maltese"],
  ["MY", "Burmese"],
  ["NB", "Norwegian (Bokmål)"],
  ["ND", "North Ndebele"],
  ["NE", "Nepali"],
  ["NL", "Dutch"],
  ["NN", "Norwegian Nynorsk"],
  ["NO", "Norwegian"],
  ["OM", "Oromo"],
  ["OR", "Odia"],
  ["OS", "Ossetic"],
  ["PA", "Punjabi"],
  ["PL", "Polish"],
  ["PS", "Pashto"],
  ["PT", "Portuguese"],
  ["PT_BR", "Portuguese (Brazil)"],
  ["PT_PT", "Portuguese (Portugal)"],
  ["QU", "Quechua"],
  ["RM", "Romansh"],
  ["RN", "Rundi"],
  ["RO", "Romanian"],
  ["RU", "Russian"],
  ["RW", "Kinyarwanda"],
  ["SA", "Sanskrit"],
  ["SC", "Sardinian"],
  ["SD", "Sindhi"],
  ["SE", "Northern Sami"],
  ["SG", "Sango"],
  ["SH", "Serbo-Croatian"],
  ["SI", "Sinhala"],
  ["SK", "Slovak"],
  ["SL", "Slovenian"],
  ["SN", "Shona"],
  ["SO", "Somali"],
  ["SQ", "Albanian"],
  ["SR", "Serbian"],
  ["SU", "Sundanese"],
  ["SV", "Swedish"],
  ["SW", "Swahili"],
  ["TA", "Tamil"],
  ["TE", "Telugu"],
  ["TG", "Tajik"],
  ["TH", "Thai"],
  ["TI", "Tigrinya"],
  ["TK", "Turkmen"],
  ["TO", "Tongan"],
  ["TR", "Turkish"],
  ["TT", "Tatar"],
  ["UG", "Uyghur"],
  ["UK", "Ukrainian"],
  ["UR", "Urdu"],
  ["UZ", "Uzbek"],
  ["VI", "Vietnamese"],
  ["VO", "Volapük"],
  ["WO", "Wolof"],
  ["XH", "Xhosa"],
  ["YI", "Yiddish"],
  ["YO", "Yoruba"],
  ["ZH", "Chinese"],
  ["ZH_CN", "Chinese (Simplified)"],
  ["ZH_TW", "Chinese (Traditional)"],
  ["ZU", "Zulu"],
];

function parseCountries(text) {
  const rows = [];
  for (const line of text.split("\n")) {
    const t = line.trim();
    if (!t.startsWith("- ")) continue;
    const rest = t.slice(2);
    const m = rest.match(/^([A-Z]{2})\s+(.+)\.$/);
    if (!m) continue;
    rows.push({ value: m[1], label: m[2].trim() });
  }
  return rows;
}

/** Normalizes stored codes (en, pt-BR, zh-CN, …) for selects and labels */
export function normalizeLanguageCode(raw) {
  if (raw == null || raw === "") return "";
  const s = String(raw).trim().replace(/-/g, "_");
  if (!s) return "";
  const parts = s.split("_");
  if (parts.length === 1) return parts[0].toLowerCase();
  const [lang, region] = parts;
  return `${lang.toLowerCase()}-${region.toUpperCase()}`;
}

export const COUNTRY_OPTIONS = parseCountries(COUNTRY_LINES);

export const LANGUAGE_OPTIONS = LANGUAGE_ROWS.map(([code, label]) => ({
  label,
  value: normalizeLanguageCode(code),
}));

/** Sentinel: template applies to every country (stored as `ALL` in DB). */
export const COUNTRY_CODE_ALL = "ALL";
/** Sentinel: template applies to every language (stored lowercase `all` in DB). */
export const LANGUAGE_CODE_ALL = "all";

const ALL_COUNTRY_SELECT_OPTION = { label: "All", value: COUNTRY_CODE_ALL };
const ALL_LANGUAGE_SELECT_OPTION = { label: "All", value: LANGUAGE_CODE_ALL };

/** Country dropdown options with “All” first (for editors and lists). */
export const COUNTRY_OPTIONS_WITH_ALL = [ALL_COUNTRY_SELECT_OPTION, ...COUNTRY_OPTIONS];
/** Language dropdown options with “All” first. */
export const LANGUAGE_OPTIONS_WITH_ALL = [ALL_LANGUAGE_SELECT_OPTION, ...LANGUAGE_OPTIONS];

const REGIONAL_INDICATOR_A = 0x1f1e6;

export function flagEmojiForCountryCode(code) {
  if (!code || typeof code !== "string") return "";
  const c = code.toUpperCase();
  if (c.length !== 2 || !/^[A-Z]{2}$/.test(c) || c === "ZZ") return "";
  try {
    return String.fromCodePoint(
      REGIONAL_INDICATOR_A + c.charCodeAt(0) - 65,
      REGIONAL_INDICATOR_A + c.charCodeAt(1) - 65,
    );
  } catch {
    return "";
  }
}

export function countryLabel(code) {
  if (String(code ?? "").toUpperCase() === COUNTRY_CODE_ALL) return "All";
  const c = COUNTRY_OPTIONS.find((x) => x.value === code);
  return c ? c.label : code || "—";
}

export function countryDisplay(code) {
  if (String(code ?? "").toUpperCase() === COUNTRY_CODE_ALL) {
    return { flag: "", name: "All" };
  }
  const c = COUNTRY_OPTIONS.find((x) => x.value === code);
  const name = c ? c.label : code || "—";
  const flag = flagEmojiForCountryCode(typeof code === "string" ? code : "");
  return { flag, name };
}

export function languageLabel(code) {
  if (code == null || code === "") return "—";
  const normalized = normalizeLanguageCode(code);
  if (normalized === LANGUAGE_CODE_ALL) return "All";
  const l = LANGUAGE_OPTIONS.find((x) => x.value === normalized);
  return l ? l.label : String(code) || "—";
}
